module.exports = __webpack_public_path__ + "img/libros_universidades.2e217a41.webp";